export class ClientNoteViewModel {
  id?: string;
  clientId: string;
  clientName?: string;
  note: string;
  status: string;
  type: string;
  dateCreatedUtc: Date;
  dateDeletedUtc?: Date;
  createdByUserId?: string;
  createdByUserName?: string;
}
